(function ($) {

  // ─── Mobile slider registry ───────────────────────────────────────────────
  // Add an entry here to create a new mobile-only Slick slider.
  // Keys in `options` are standard Slick options.
  var mobileSliders = [
    {
      selector: '.collection-list',
      options: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: true,
        adaptiveHeight: false
      }
    },
    {
      selector: '.featured-collection .product-grid--rows',
      options: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: true,
        adaptiveHeight: false
      }
    },
    {
      selector: '.product-recommendations .product-grid--rows',
      options: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: true,
        adaptiveHeight: false
      }
    }
  ];
  // ─────────────────────────────────────────────────────────────────────────

  var BREAKPOINT = 768;
  var PRODUCT_BREAKPOINT = 1024;

  function isMobile() {
    return window.innerWidth < BREAKPOINT;
  }

  function isBelowProductBreakpoint() {
    return window.innerWidth < PRODUCT_BREAKPOINT;
  }

  function initSliders() {
    mobileSliders.forEach(function (config) {
      $(config.selector).each(function () {
        var $el = $(this);
        if (isMobile() && !$el.hasClass('slick-initialized')) {
          $el.slick(config.options);
        } else if (!isMobile() && $el.hasClass('slick-initialized')) {
          $el.slick('unslick');
        }
      });
    });
  }

  var resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      initSliders();
      repositionProductDescription();
    }, 200);
  });

  // ─── Trust bar marquee ────────────────────────────────────────────────────
  function initTrustBar(bar) {
    if (!isMobile()) return;
    if (bar.dataset.trustInit) return;
    bar.dataset.trustInit = 'true';

    var items = Array.from(bar.querySelectorAll('.trust-item'));
    if (!items.length) return;

    var track = document.createElement('div');
    track.className = 'collection-trust-bar__track';
    items.forEach(function (item) { track.appendChild(item); });
    items.forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
    bar.appendChild(track);
  }

  function initSliderEl(el) {
    mobileSliders.forEach(function (config) {
      if (el.matches(config.selector) && isMobile() && !$(el).hasClass('slick-initialized')) {
        $(el).slick(config.options);
      }
    });
  }

  // Catches elements injected via innerHTML (e.g. product-recommendations AJAX)
  var trustObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        // Trust bars
        var bars = node.classList && node.classList.contains('collection-trust-bar')
          ? [node]
          : Array.from(node.querySelectorAll ? node.querySelectorAll('.collection-trust-bar') : []);
        bars.forEach(initTrustBar);

        // Slick sliders
        mobileSliders.forEach(function (config) {
          var els = node.matches && node.matches(config.selector)
            ? [node]
            : Array.from(node.querySelectorAll ? node.querySelectorAll(config.selector) : []);
          els.forEach(initSliderEl);
        });
      });
    });
  });
  // ─────────────────────────────────────────────────────────────────────────

  // ─── Product thumbnail strip slider ──────────────────────────────────────
  function updateProductFeaturedImage($thumbItem) {
    var $container = $thumbItem.closest('[data-section-id]');
    var $featuredImage = $container.find('[data-product-featured-media]');
    var html = $thumbItem.find('.thumbnail-media-template').html();
    if (!html || !$featuredImage.length) return;

    if (window.theme && theme.ProductMedia) theme.ProductMedia.destroy($container);
    $featuredImage.html(html);
    if (window.theme && theme.ProductMedia) theme.ProductMedia.init($container, { autoplayFirstMedia: true });

    $thumbItem.addClass('product-thumbnails__item--active')
      .siblings('.product-thumbnails__item--active').removeClass('product-thumbnails__item--active');
  }

  function initProductThumbnailSlider() {
    var $thumbs = $('.product-thumbs-strip');
    if (!$thumbs.length) return;

    if (!$thumbs.hasClass('slick-initialized')) {
      $thumbs.slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        responsive: [
          {
            breakpoint: PRODUCT_BREAKPOINT,
            settings: { slidesToShow: 4 }
          },
          {
            breakpoint: BREAKPOINT,
            settings: { slidesToShow: 3 }
          }
        ]
      });

      // Slide change → update main image
      $thumbs.on('afterChange.thumbStrip', function (evt, slick, currentIndex) {
        updateProductFeaturedImage($(slick.$slides[currentIndex]).find('.product-thumbnails__item'));
      });

      // Click → update main image (stopPropagation prevents theme's carousel handler)
      $thumbs.on('click.thumbStrip', '[data-product-single-thumbnail]', function (e) {
        e.preventDefault();
        e.stopPropagation();
        updateProductFeaturedImage($(this).closest('.product-thumbnails__item'));
      });
    }
  }

  $(window).on('debouncedresize', function () {
    initProductThumbnailSlider();
  });
  // ─────────────────────────────────────────────────────────────────────────

  // ─── Product description reposition ──────────────────────────────────────
  function repositionProductDescription() {
    var desc = document.querySelector('.product-description.product__block--first');
    var imagesGrid = document.querySelector('.product-images-grid');
    if (!desc || !imagesGrid) return;

    if (isBelowProductBreakpoint() && imagesGrid.contains(desc)) {
      var productDetails = document.querySelector('.product-details');
      var target = productDetails ? productDetails.nextSibling : imagesGrid.nextSibling;
      imagesGrid.parentNode.insertBefore(desc, target);
    } else if (!isBelowProductBreakpoint() && !imagesGrid.contains(desc)) {
      imagesGrid.appendChild(desc);
    }
  }
  // ─────────────────────────────────────────────────────────────────────────

  $(document).ready(function () {
    initSliders();
    repositionProductDescription();
    initProductThumbnailSlider();

    // Init any trust bars already in the DOM (non-AJAX sections)
    document.querySelectorAll('.collection-trust-bar').forEach(initTrustBar);

    // Watch for dynamically injected trust bars
    trustObserver.observe(document.body, { childList: true, subtree: true });
  });

})(jQuery);
